import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=bbba414c&"
import script from "./DeleteIcon.vue?vue&type=script&lang=js&"
export * from "./DeleteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports